import { render, staticRenderFns } from "./SituacaoList.vue?vue&type=template&id=78a97e23&scoped=true"
import script from "./SituacaoList.vue?vue&type=script&lang=js"
export * from "./SituacaoList.vue?vue&type=script&lang=js"
import style0 from "./SituacaoList.vue?vue&type=style&index=0&id=78a97e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a97e23",
  null
  
)

export default component.exports